/**
 * Route access utilities shared across client and server modules.
 */

import { routing } from "@/i18n/routing";

export const PROTECTED_ROUTES = ["/account", "/creator", "/onboarding"];

const NON_LOCALIZED_ROUTES = [
  "/login",
  "/register",
  "/reset-password",
  "/goodbye",
  "/p",
  ...PROTECTED_ROUTES,
];

export function isProtectedAccess(pathname: string): boolean {
  return isRouteMatch(PROTECTED_ROUTES, pathname);
}

export function shouldSkipIntlMiddleware(pathname: string): boolean {
  return isRouteMatch(NON_LOCALIZED_ROUTES, pathname);
}

function isRouteMatch(routes: string[], pathname: string): boolean {
  return routes.some(
    (route) => pathname === route || pathname.startsWith(route + "/"),
  );
}

export function getLocalePathname(pathname: string, locale: string): string {
  if (shouldSkipIntlMiddleware(pathname)) return pathname;

  const localePathname = locale === routing.defaultLocale ? "/" : `/${locale}`;
  return pathname === "/" ? localePathname : `${localePathname}${pathname}`;
}
